import RecipeVariantTableBody from "./RecipeVariantTableBody";
import RecipeVariantTableHeader from "./RecipeVariantTableHeader";
import { RecipeVariantTableProps } from "./recipeVariantTable.types";

const RecipeVariantTable = ({
  fixedColumns,
  dynamicColumns,
  ...bodyProps
}: RecipeVariantTableProps) => {
  return (
    <div className="tw-border tw-border-border tw-rounded-lg tw-overflow-hidden tw-bg-card">
      <div className="tw-overflow-x-auto">
        <table className="tw-w-full tw-text-sm">
          <RecipeVariantTableHeader
            fixedColumns={fixedColumns}
            dynamicColumns={dynamicColumns}
            variants={bodyProps.variants}
            recipeId={bodyProps.recipeId}
            addDeleteColumn={bodyProps.addDeleteColumn}
            readOnly={bodyProps.readOnly}
            onVariantNameUpdated={bodyProps.onVariantNameUpdated}
            onOpenEditVariation={bodyProps.onOpenEditVariation}
          />
          <RecipeVariantTableBody
            fixedColumns={fixedColumns}
            dynamicColumns={dynamicColumns}
            {...bodyProps}
          />
        </table>
      </div>
    </div>
  );
};

export default RecipeVariantTable;
